import { render, staticRenderFns } from "./addexamaddorupdate.vue?vue&type=template&id=45080b2e"
import script from "./addexamaddorupdate.vue?vue&type=script&lang=js"
export * from "./addexamaddorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports